import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";

export default class KeyDecisionContentEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {Content} content 
     * @param {NGTScenarioPlayer} contentPlayer 
     */
    constructor(type, content, contentPlayer) {
        this.type = type;
        this.content = content;
        this.contentPlayer = contentPlayer;
    }
}

KeyDecisionContentEvent.KEY_DECISION_CONTENT_AVAILABLE = "KeyDecisionContentEvent.KEY_DECISION_CONTENT_AVAILABLE";
KeyDecisionContentEvent.KEY_DECISION_CONTENT_UNAVAILABLE = "KeyDecisionContentEvent.KEY_DECISION_CONTENT_UNAVAILABLE";
KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED = "KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED";